import styled from 'styled-components';

export const Head = styled.div`
  display: flex;
  gap: 14px;
  margin-bottom: 8px;
`;

export const HeadImage = styled.div`
  flex: 0 0 112px;
  width: 112px;
  height: 112px;
  border-radius: 10px;
  background: #f5f5f5;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #bfbfbf;
  font-size: 32px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const HeadInfo = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;

  .brand {
    color: #8c8c8c;
  }

  .model {
    font-size: 17px;
    font-weight: 600;
    overflow-wrap: anywhere;
  }

  .price {
    font-size: 16px;
    font-weight: 600;
  }

  .ant-tag {
    align-self: flex-start;
    margin: 0;
  }
`;

export const CategoryGroup = styled.div`
  margin-bottom: 14px;

  .name {
    margin-bottom: 6px;
    color: #595959;
    font-size: 13px;
  }

  .ant-tag {
    margin: 0 6px 6px 0;
    padding: 2px 10px;
    font-size: 14px;
  }
`;

export const ImageGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;

  .ant-image,
  .ant-image-img {
    width: 100%;
    aspect-ratio: 1;
    object-fit: cover;
    border-radius: 8px;
  }
`;

export const Empty = styled.div`
  padding: 24px 0;
  text-align: center;
  color: #8c8c8c;
`;
